var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "sop_dialog",
      attrs: {
        title: _vm.$t("navbar.viewSOP"),
        visible: _vm.isShow,
        center: "",
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "border-radius": "0 !important" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "header-cell-style": { background: "#f7f7f9" },
            "max-height": "300",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("navbar.documentName"),
              prop: "documentName",
              align: "center",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.fileName"),
              prop: "fileName",
              align: "center",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.LatestVersion"),
              prop: "currentVersionName",
              align: "center",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.Updater"),
              prop: "updateUserName",
              align: "center",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.UpdateTime"),
              prop: "updateTime",
              align: "center",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.operation"),
              align: "center",
              width: "235",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", round: "", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.preView(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("operationCenter.Preview")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", round: "", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.download(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Download")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }